import { BannerPlacement } from '@hook/useAnimatedAppsBanner';
import { useDesktopOrWider } from '@utils/mediaQuery';
import { AnimatedAppsPromotionBannerDesktop } from '@components/AnimatedAppsPromotionBannerDesktop';
import { AnimatedAppsPromotionBannerMobile } from '@components/AnimatedAppsPromotionBannerMobile';

interface Props {
  className?: string,
  isVisible?: boolean,
  placement: BannerPlacement,
  onClose: () => void,
}

export const AnimatedAppsPromotionBanner: React.FC<Props> = ({
  className,
  isVisible = true,
  placement,
  onClose,
}) => {
  const isDesktop = useDesktopOrWider();

  if (isDesktop) {
    return (
      <AnimatedAppsPromotionBannerDesktop
        className={className}
        isVisible={isVisible}
        placement={placement}
        onClose={onClose}
      />
    );
  }

  return (
    <AnimatedAppsPromotionBannerMobile
      className={className}
      isVisible={isVisible}
      placement={placement}
      onClose={onClose}
    />
  );
};
